export default __webpack_public_path__ + "static/media/poppins-regular.467ce08c.woff";